










import { defineComponent, PropType } from '@nuxtjs/composition-api';
import ProductCarousel from '@shared/components/ProductCarousel/ProductCarousel.vue';
import { getCTALink } from '@shared/composables/useUiHelpers';
import { Product } from '@unified-commerce/gpc-vue-storefront-shopify';

export default defineComponent({
  name: 'ProductCarouselAuto',
  components: {
    ProductCarousel,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    button_link: {
      type: Object,
      default: () => ({}),
    },
    button_text: {
      type: String,
      default: '',
    },
    items: {
      type: Array as PropType<Product[]>,
      default: () => [],
    },
  },
  setup() {
    const getButtonLink = (link: any) => {
      return link && Object.keys(link).length ? getCTALink(link) : {};
    };

    return {
      getButtonLink,
      getCTALink,
    };
  },
});
